import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './Saved.css';
import Loader from '../../layout/Loder';
import { Helmet } from 'react-helmet';
import EmptyState from './EmptyState';
import PlanCard from './PlanCard';
import { getSavedPlans } from '../../actions/postAction';

const Saved = () => {
  const dispatch = useDispatch();
  const { loading, savedPlans = [] } = useSelector((state) => state.savedPlans);

  useEffect(() => {
    dispatch(getSavedPlans());
  }, [dispatch]);

  return (
    <div className='search'>
      <Helmet>
        <title>Saved Visions | dmyor</title>
        <link rel="canonical" href="https://www.dmyor.com/dashboard/saved" />
      </Helmet>
      {loading ? (
        <Loader />
      ) : (
        <>
          {savedPlans.length > 0 ? (
            <>
              <div className="saved-header">
                <h2>Saved Visions</h2>
                <p>Visions from others you've bookmarked.</p>
              </div>
              <div className="saved-plans-list">
                {savedPlans.filter(Boolean).map((plan) => (
                  <PlanCard key={plan._id} plan={plan} />
                ))}
              </div>
            </>
          ) : (
            <div className="saved-empty-wrap">
              <EmptyState
                variant="saved"
                title="Saved visions will live here"
                description="Once the Explore feed opens, you'll be able to browse public visions and save the ones that resonate. Join the waitlist to get in first."
                ctaLabel="Join the Explore waitlist"
                ctaTo="/dashboard/search"
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Saved;
